import api from 'api';

const url = 'api/events/:id/sections';

export default {
    fetchSections: id => api.get({path: url.replace(':id', +id)})
}